import { Link } from "react-router-dom";
import OrderExchange from "../exchange/orderExchange/orderExchange";
import { useEffect } from "react";

const FooterComponent = ({ onLoginClick, onSignupClick, auth }) => {
  useEffect(() => {
    // Create the JivoSite widget script element
    const script = document.createElement("script");

    script.src = "//code.jivosite.com/widget/a1lfIl2l9Q";
    script.async = true;

    // Append the script to the body
    document.body.appendChild(script);

    // Cleanup the script when the component unmounts
    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <>
      <footer className="sec-pad-t">
        <div className="container">
          <div className="row foot-menu">
            <div className="col-xl-7 col-md-6">
              <div className="row">
                <div className="col-xl-3 first-box">
                  <h4>Navigation</h4>
                  <ul>
                    <li>
                      <Link to="/">Home</Link>
                    </li>
                    <li>
                      <Link to="/how-it-works">How it works</Link>
                    </li>
                    <li>
                      <Link to="/about-us">About us</Link>
                    </li>
                    <li>
                      <Link to="/faq">FAQ</Link>
                    </li>
                    <li>
                      <Link to="/contact-us">Contact us</Link>
                    </li>
                  </ul>
                </div>
                <div className="col-xl-6 first-box">
                  <h4>Popular pairs</h4>

                  <div className="row">
                    <div className="col-xl-6">
                      <ul>
                        <li>
                          <Link to="/coin/BTC/1/USD/pair">BTC to USD</Link>
                        </li>
                        <li>
                          <Link to="/coin/USDC/1/USD/pair">USDC to USD</Link>
                        </li>
                        <li>
                          <Link to="/coin/ETH/1/USD/pair">ETH to USD</Link>
                        </li>
                        <li>
                          <Link to="/coin/USDT/1/USD/pair">USDT to USD</Link>
                        </li>
                      </ul>
                    </div>
                    <div className="col-xl-6">
                      <ul>
                        <li>
                          <Link to="/coin/BTC/1/EUR/pair">BTC to EUR</Link>
                        </li>
                        <li>
                          <Link to="/coin/USDC/1/EUR/pair">USDC to EUR</Link>
                        </li>
                        <li>
                          <Link to="/coin/ETH/1/EUR/pair">ETH to EUR</Link>
                        </li>
                        <li>
                          <Link to="/coin/USDT/1/EUR/pair">USDT to EUR</Link>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div className="col-xl-3 last-box">
                  <h4>Legal</h4>
                  <ul>
                    <li>
                      <Link to="/aml-kyc">AML/KYC Policy</Link>
                    </li>
                    <li>
                      <Link to="/privacy-policy">Privacy Policy</Link>
                    </li>
                    <li>
                      <Link to="/terms-of-use">Terms Of Use </Link>
                    </li>

                    {/* <li>
                      <a href="#">Terms of Use</a>
                    </li> */}
                  </ul>
                </div>
              </div>

              <div className="social-ico">
                <a target="_blank" href="https://t.me/kittrow">
                  <img src="/assets/images/teegram.png" />
                </a>
                <a target="_blank" href="https://wa.me/+420296249177">
                  <img src="/assets/images/WhatsApp.png" />
                </a>
              </div>
            </div>
            <div className="col-xl-5 col-md-6">
              <div className="btm-ex-fom">
                <OrderExchange
                  tabId="footer-home"
                  onLoginClick={onLoginClick}
                />
              </div>
            </div>
          </div>
        </div>

        <div className="container">
          <div className="copy-rt text-center">
            <p>Copyright © 2024 - 2025 Kittrow Investments s.r.o. All rights reserved.</p>
          </div>
        </div>
      </footer>
    </>
  );
};

export default FooterComponent;
